// extracted by mini-css-extract-plugin
export var container = "_do-1";
export var cornerButtonContainer = "_do-6";
export var disabled = "_do-2";
export var dragActive = "_do-3";
export var fileContainer = "_do-5";
export var hiddenInput = "_do-4";
export var widthContainer = "_do-0";